/** Explicit event vocabulary: add a mapping when introducing a new UI action. */
export const interactionActions = {
	Opened: "opened",
	Removed: "removed",
	LoadMore: "load_more",
	Reloaded: "reloaded",
	Saved: "saved",
	CreatePerson: "create_person",
	DismissedSuccess: "success_dismissed",
	EditorChanged: "text_changed",
	EditorFocusChanged: "focus_changed",
	Searched: "search_submitted",
	CroppedImage: "image_cropped",
	CropCancelled: "crop_cancelled",
	UpdatedInputValue: "input_changed",
	SelectedItem: "item_selected",
	RequestedClose: "close_requested",
	RequestedOpen: "open_requested",
	ChangedAmount: "amount_changed",
	ChangedAttributeKey: "attribute_key_changed",
	ChangedAttributeType: "attribute_type_changed",
	ChangedAttributeValue: "attribute_value_changed",
	ChangedBody: "body_changed",
	ChangedCadence: "cadence_changed",
	ChangedDescription: "description_changed",
	ChangedEditorFocus: "editor_focus_changed",
	ChangedEmail: "email_changed",
	ChangedEntityType: "entity_type_changed",
	ChangedEntryType: "entry_type_changed",
	ChangedFile: "file_changed",
	ChangedFilter: "filter_changed",
	ChangedGenerationConfig: "generation_config_changed",
	ChangedImageFile: "image_file_changed",
	ChangedInput: "input_changed",
	ChangedKey: "key_changed",
	ChangedKeyDescription: "key_description_changed",
	ChangedLabel: "label_changed",
	ChangedName: "name_changed",
	ChangedNotes: "notes_changed",
	ChangedOccurredOn: "occurred_on_changed",
	ChangedPage: "page_changed",
	ChangedPerson: "person_changed",
	ChangedQuery: "query_changed",
	ChangedRecordType: "record_type_changed",
	ChangedSearch: "search_changed",
	ChangedSearchText: "search_text_changed",
	ChangedSearchType: "search_type_changed",
	ChangedSortOrder: "sort_order_changed",
	ChangedSubType: "sub_type_changed",
	ChangedSubtitle: "subtitle_changed",
	ChangedSwapTarget: "swap_target_changed",
	ChangedTags: "tags_changed",
	ChangedTask: "task_changed",
	ChangedTitle: "title_changed",
	ChangedTopupAmount: "topup_amount_changed",
	ChangedType: "type_changed",
	ChangedValue: "value_changed",
	ChangedValueType: "value_type_changed",
	Chose: "chose",
	ChoseResolution: "chose_resolution",
	Cleared: "cleared",
	ClickedAccountMenu: "account_menu_clicked",
	ClickedAdd: "add_clicked",
	ClickedAddAttribute: "add_attribute_clicked",
	ClickedAddEntry: "add_entry_clicked",
	ClickedAddRecord: "add_record_clicked",
	ClickedAddTask: "add_task_clicked",
	ClickedAdjust: "adjust_clicked",
	ClickedBack: "back_clicked",
	ClickedBackToCrop: "back_to_crop_clicked",
	ClickedBulk: "bulk_clicked",
	ClickedCancel: "cancel_clicked",
	ClickedCancelEdit: "cancel_edit_clicked",
	ClickedCancelGeneration: "cancel_generation_clicked",
	ClickedCancelLink: "cancel_link_clicked",
	ClickedChangeImage: "change_image_clicked",
	ClickedCleanup: "cleanup_clicked",
	ClickedClose: "close_clicked",
	ClickedCloseImageModal: "close_image_modal_clicked",
	ClickedCloseNavigation: "close_navigation_clicked",
	ClickedConfirm: "confirm_clicked",
	ClickedConfirmDelete: "confirm_delete_clicked",
	ClickedConfirmUndo: "confirm_undo_clicked",
	ClickedConnect: "connect_clicked",
	ClickedContinue: "continue_clicked",
	ClickedCopy: "copy_clicked",
	ClickedCreate: "create_clicked",
	ClickedCreateKey: "create_key_clicked",
	ClickedDelete: "delete_clicked",
	ClickedDeleteBilling: "delete_billing_clicked",
	ClickedDeleteKey: "delete_key_clicked",
	ClickedDeveloperOptions: "developer_options_clicked",
	ClickedDisconnect: "disconnect_clicked",
	ClickedDismissError: "dismiss_error_clicked",
	ClickedDismissPaymentSuccess: "dismiss_payment_success_clicked",
	ClickedDownload: "download_clicked",
	ClickedEdit: "edit_clicked",
	ClickedEditorAction: "editor_action_clicked",
	ClickedEntry: "entry_clicked",
	ClickedExitTimeTravel: "exit_time_travel_clicked",
	ClickedExport: "export_clicked",
	ClickedGenerate: "generate_clicked",
	ClickedGoBack: "go_back_clicked",
	ClickedHistory: "history_clicked",
	ClickedItem: "item_clicked",
	ClickedJoinWaitlist: "join_waitlist_clicked",
	ClickedLink: "link_clicked",
	ClickedLoadMore: "load_more_clicked",
	ClickedLoadMoreEntries: "load_more_entries_clicked",
	ClickedLoadMoreHistory: "load_more_history_clicked",
	ClickedLogInteraction: "log_interaction_clicked",
	ClickedMerge: "merge_clicked",
	ClickedNotThisPerson: "not_this_person_clicked",
	ClickedOpenNavigation: "open_navigation_clicked",
	ClickedOrganizationSwitcher: "organization_switcher_clicked",
	ClickedOverlay: "overlay_clicked",
	ClickedPause: "pause_clicked",
	ClickedPortal: "portal_clicked",
	ClickedReachOut: "reach_out_clicked",
	ClickedRefresh: "refresh_clicked",
	ClickedRemove: "remove_clicked",
	ClickedRemoveAttribute: "remove_attribute_clicked",
	ClickedRemoveTag: "remove_tag_clicked",
	ClickedRemoveTask: "remove_task_clicked",
	ClickedRestart: "restart_clicked",
	ClickedRetryMatch: "retry_match_clicked",
	ClickedSave: "save_clicked",
	ClickedSendTest: "send_test_clicked",
	ClickedSkip: "skip_clicked",
	ClickedSwap: "swap_clicked",
	ClickedSwapIn: "swap_in_clicked",
	ClickedSync: "sync_clicked",
	ClickedSystemTheme: "system_theme_clicked",
	ClickedThemeToggle: "theme_toggle_clicked",
	ClickedToggle: "toggle_clicked",
	ClickedToggleTask: "toggle_task_clicked",
	ClickedTopup: "topup_clicked",
	ClickedUndo: "undo_clicked",
	ClickedUnpause: "unpause_clicked",
	ClickedUpload: "upload_clicked",
	ClickedViewAt: "view_at_clicked",
	Closed: "closed",
	PressedEnter: "enter_pressed",
	PressedEscape: "escape_pressed",
	PressedSearchShortcut: "search_shortcut_pressed",
	PressedToggleButton: "toggle_button_pressed",
	Selected: "selected",
	SelectedPerson: "person_selected",
	SelectedTab: "tab_selected",
	SelectedTagVariant: "tag_variant_selected",
	SelectedTimeTravelDate: "time_travel_date_selected",
	SelectedVariant: "variant_selected",
	Submitted: "submitted",
	SubmittedAddRecord: "add_record_submitted",
	SubmittedEdit: "edit_submitted",
	SubmittedForm: "form_submitted",
	ToggledAdditionalData: "additional_data_toggled",
	ToggledDate: "date_toggled",
	ToggledFormat: "format_toggled",
	ToggledHistoryCard: "history_card_toggled",
	ToggledHistoryVersion: "history_version_toggled",
	ToggledIntegrations: "integrations_toggled",
	ToggledRow: "row_toggled",
	ToggledSelect: "select_toggled",
	ToggledSelectAll: "select_all_toggled",
	ToggledTags: "tags_toggled",
	ToggledToolLog: "tool_log_toggled",
} as const satisfies Readonly<Record<string, string>>;
